import "./@global/wdyr";
import logger from "./@global/logger";

import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";

// Redux
import { Provider } from "react-redux";
import Store from "./redux/Store";

// Components
import App from "./App";

if (!window._env_) {
  window._env_ = {};

  logger.error("No 'window._env_' was found!");
}

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
